import { IFeatureToggleApi } from '../api/featureToggleApi'
import { parseFeatureToggleMap } from '../util/featureToggleParser'
import { useFeatureToggleStore } from '../store/featureToggelStore'

export class FeatureToggleService {
  private _api: IFeatureToggleApi
  constructor(api: IFeatureToggleApi) {
    this._api = api
  }

  async getFeatureToggle(): Promise<void> {
    const toggleString = await this._api.getFeatureToggle()
    const toggleList = parseFeatureToggleMap(toggleString)
    useFeatureToggleStore.setState({
      toggleList,
    })
  }
}
